var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgDelivery = _a => {
  var _b, _c, _d, _e, _f, _g, _h;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97925 12.3004C3.97925 11.9096 4.29606 11.5928 4.68688 11.5928H7.98914C8.37995 11.5928 8.69677 11.9096 8.69677 12.3004C8.69677 12.6912 8.37995 13.008 7.98914 13.008H4.68688C4.29606 13.008 3.97925 12.6912 3.97925 12.3004Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64563 16.597C5.64563 16.2062 5.96245 15.8894 6.35326 15.8894H7.76851C8.15933 15.8894 8.47614 16.2062 8.47614 16.597C8.47614 16.9878 8.15933 17.3047 7.76851 17.3047H6.35326C5.96245 17.3047 5.64563 16.9878 5.64563 16.597Z",
    fill: (_d = props.color) !== null && _d !== void 0 ? _d : 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.31042 8.00401C2.31042 7.6132 2.62724 7.29639 3.01805 7.29639H8.11298C8.50379 7.29639 8.8206 7.6132 8.8206 8.00401C8.8206 8.39483 8.50379 8.71164 8.11298 8.71164H3.01805C2.62724 8.71164 2.31042 8.39483 2.31042 8.00401Z",
    fill: (_e = props.color) !== null && _e !== void 0 ? _e : 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7546 6.4375H17.3848C18.1469 6.4375 18.81 6.95906 18.9895 7.6997L19.5716 10.1015L22.1057 11.4084C22.6549 11.6916 23 12.2579 23 12.8758V16.5131C23 17.425 22.2608 18.1642 21.3489 18.1642H17.9845V16.7489H21.3489C21.4791 16.7489 21.5847 16.6433 21.5847 16.5131V12.8758C21.5847 12.7876 21.5354 12.7067 21.457 12.6662L18.3484 11.0631L17.614 8.03307C17.5884 7.92727 17.4937 7.85276 17.3848 7.85276H12.1699V16.7489H14.591V18.1642H10.7546V6.4375Z",
    fill: (_f = props.color) !== null && _f !== void 0 ? _f : 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3.70763C1 3.31682 1.31682 3 1.70763 3H11.4593C11.8501 3 12.1669 3.31682 12.1669 3.70763V7.14478C12.1669 7.53559 11.8501 7.8524 11.4593 7.8524C11.0685 7.8524 10.7517 7.53559 10.7517 7.14478V4.41526H1.70763C1.31682 4.41526 1 4.09844 1 3.70763Z",
    fill: (_g = props.color) !== null && _g !== void 0 ? _g : 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1251 18.315C19.1251 19.8876 17.8503 21.1624 16.2778 21.1624C14.7052 21.1624 13.4304 19.8876 13.4304 18.315C13.4304 16.7425 14.7052 15.4677 16.2778 15.4677C17.8503 15.4677 19.1251 16.7425 19.1251 18.315ZM17.7099 18.315C17.7099 19.1059 17.0687 19.7471 16.2778 19.7471C15.4869 19.7471 14.8457 19.1059 14.8457 18.315C14.8457 17.5241 15.4869 16.8829 16.2778 16.8829C17.0687 16.8829 17.7099 17.5241 17.7099 18.315Z",
    fill: (_h = props.color) !== null && _h !== void 0 ? _h : 'currentColor'
  }));
};
export default SvgDelivery;